import { useState } from 'react';
import type { AssessmentQuestion } from '@/lib/types';
import { inlineMarkdown } from '@/lib/markdown';

interface MultipleChoiceProps {
  question: AssessmentQuestion;
  onAnswer: (answer: string | string[]) => void;
  disabled?: boolean;
  currentAnswer?: string | string[];
}

export function MultipleChoice({
  question,
  onAnswer,
  disabled = false,
  currentAnswer,
}: MultipleChoiceProps) {
  const [selected, setSelected] = useState<string>(
    typeof currentAnswer === 'string' ? currentAnswer : ''
  );

  const handleSelect = (option: string) => {
    if (disabled) return;
    setSelected(option);
    onAnswer(option);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100"
          dangerouslySetInnerHTML={{ __html: inlineMarkdown(question.question) }} />

      <div className="space-y-2">
        {question.options?.map((option, idx) => (
          <button
            key={idx}
            onClick={() => handleSelect(option)}
            disabled={disabled}
            className={`
              w-full text-left px-4 py-3 rounded-lg border-2 transition-all
              ${
                selected === option
                  ? 'accent-border accent-bg-medium accent-text-dark'
                  : 'border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          >
            <div className="flex items-center gap-3">
              <div
                className={`
                  w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0
                  ${
                    selected === option
                      ? 'accent-border accent-bg'
                      : 'border-slate-300 dark:border-slate-600'
                  }
                `}
              >
                {selected === option && (
                  <div className="w-2 h-2 rounded-full bg-white"></div>
                )}
              </div>
              <span className="text-sm"
                    dangerouslySetInnerHTML={{ __html: inlineMarkdown(option) }} />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
